import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { Chip, Text, useTooltip } from '@frontend/design-system';

interface LocationTrialDetail {
  id: string;
  name: string;
  daysRemaining: number;
}

interface TrialLocationChipProps {
  locations: LocationTrialDetail[];
  isMultiLocation: boolean;
}

export const TrialLocationChip: React.FC<TrialLocationChipProps> = ({ locations, isMultiLocation }) => {
  const { t } = useTranslation('call-intelligence');
  const { triggerProps, tooltipProps, Tooltip } = useTooltip({
    placement: 'bottom-start',
  });

  if (!isMultiLocation || locations.length === 0) {
    return null;
  }

  return (
    <>
      <div {...triggerProps}>
        <Chip variant='neutral' leftElement={<Icon name='locations-small' />} css={styles.chip}>
          {locations.length}
        </Chip>
      </div>

      <Tooltip {...tooltipProps} css={styles.tooltip}>
        <Text as='div' size='medium' color='white' weight='bold'>
          {t('Locations on Free Trial:')}
        </Text>
        <ul css={styles.tooltipList}>
          {locations.map((loc) => (
            <li key={loc.id}>
              <Text as='span' size='medium' color='white'>
                {loc.name}
              </Text>
            </li>
          ))}
        </ul>
      </Tooltip>
    </>
  );
};

const styles = {
  chip: css`
    gap: var(--fabric-space-gap-xxs);
    cursor: default;
    padding: var(--fabric-space-padding-xxs);
  `,
  tooltip: css`
    max-width: 420px;
    display: flex;
    flex-direction: column;
    gap: var(--fabric-space-gap-xs);
  `,
  tooltipList: css`
    margin: 0;
    padding-left: var(--fabric-space-padding-md);
    display: flex;
    flex-direction: column;
    gap: var(--fabric-space-gap-xxs);
  `,
};
